import { render, staticRenderFns } from "./ListNavigations.vue?vue&type=template&id=197bcb6e&scoped=true&"
import script from "./ListNavigations.vue?vue&type=script&lang=js&"
export * from "./ListNavigations.vue?vue&type=script&lang=js&"
import style0 from "./ListNavigations.vue?vue&type=style&index=0&id=197bcb6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197bcb6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('197bcb6e')) {
      api.createRecord('197bcb6e', component.options)
    } else {
      api.reload('197bcb6e', component.options)
    }
    module.hot.accept("./ListNavigations.vue?vue&type=template&id=197bcb6e&scoped=true&", function () {
      api.rerender('197bcb6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/ScreenBuilder/components/ListNavigations.vue"
export default component.exports